export const HOLE_CREATE_REQUEST = 'HOLE_CREATE_REQUEST'
export const HOLE_CREATE_SUCCESS = 'HOLE_CREATE_SUCCESS'
export const HOLE_CREATE_FAIL    = 'HOLE_CREATE_FAIL'
export const HOLE_CREATE_RESET   = 'HOLE_CREATE_RESET'

export const HOLE_UPDATE_REQUEST = 'HOLE_UPDATE_REQUEST'
export const HOLE_UPDATE_SUCCESS = 'HOLE_UPDATE_SUCCESS'
export const HOLE_UPDATE_FAIL    = 'HOLE_UPDATE_FAIL'
export const HOLE_UPDATE_RESET   = 'HOLE_UPDATE_RESET'

export const HOLE_DELETE_REQUEST = 'HOLE_DELETE_REQUEST'
export const HOLE_DELETE_SUCCESS = 'HOLE_DELETE_SUCCESS'
export const HOLE_DELETE_FAIL    = 'HOLE_DELETE_FAIL'
